import React from 'react';
import { trustBadges } from '../../mock';
import { ShieldCheck } from 'lucide-react';

const TrustBadges = () => {
  return (
    <section className="py-14 border-y border-[rgba(31,58,46,0.08)] bg-[var(--brand-cream)]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
          <div className="flex items-center gap-3">
            <ShieldCheck size={16} className="text-[var(--brand-gold)]" />
            <div className="text-xs uppercase tracking-[0.22em] text-[var(--brand-mute)]">
              Registered, accredited & trusted
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
            {trustBadges.map((b) => (
              <div key={b.label} className="group flex items-baseline gap-2" title={b.full}>
                <span className="font-serif text-2xl text-green tracking-tight">{b.label}</span>
                <span className="text-[10px] uppercase tracking-[0.24em] text-[var(--brand-mute)] hidden md:inline">{b.full}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
